import { makeStyles, TableBody } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import { Table, TableCell, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import styled from "styled-components";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/delete.svg";

import {
  AddItemContainer,
  ApplyFormInput,
  Button,
  Error,
  InputDiv,
  Label,
  MainTitle,
  Select,
  TableContainer,
  TableInput,
  TableSelect,
} from "../../../styles/styles";
const useStyles = makeStyles({
  table: {
    width: "100%",
    paddingTop: "30px",
  },
  thead: {
    borderBottom: "none",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "21px",
    color: "#6D83AE",
    background: "#F7F9FD",
  },
  button: {
    display: "block",
    marginTop: "20px",
  },
  formControl: {
    margin: "10px",
    minWidth: 120,
  },
});

const MoreInwards = ({ setShow, details }) => {
  console.log(
    "🚀 ~ file: MoreInwards.jsx ~ line 48 ~ MoreInwards ~ details",
    details
  );
  const classes = useStyles();
  const { agency, date, item, order, quantity, audit } = details;

  const items = [
    {
      order,
      item,
      quantity,
      date,
      received: "22",
      good_condition: "32",
      bad_condition: "34",
      code: "12demo",
      not_working: "0",
    },
    {
      order,
      item,
      quantity,
      date,
      received: "22",
      good_condition: "32",
      bad_condition: "34",
      code: "12demo",
      not_working: "0",
    },
  ];
  return (
    <AddItemContainer className="mt-5">
      <form>
        <Container>
          <Row className="w-100 p-0 m-0">
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Order No.</Label>
                <ApplyFormInput details readOnly value={order} />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Date Received</Label>
                <ApplyFormInput details readOnly value={date} required />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Agency Name</Label>
                <ApplyFormInput details type="text" readOnly value={agency} />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Generated by</Label>
                <ApplyFormInput details type="text" readOnly value={"Koeman"} />
              </InputDiv>
            </Col>
          </Row>
          <section>
            <MainTitle>All Items</MainTitle>
            <TableContainer className="w-100">
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.thead} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Item Name
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Total Qty.
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Received
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Good Condition
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Bad Condition
                    </TableCell>
                    <TableCell className={classes.thead} align="center">
                      Not Working
                    </TableCell>
                    <TableCell
                      className={classes.thead}
                      align="center"
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item, index) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          <TableInput details readOnly value={`${item.item}`}>
                          </TableInput>
                        </TableCell>
                        <TableCell align="center">
                          <TableInput details readOnly value={`${item.quantity}`} />
                        </TableCell>

                        <TableCell align="center">
                          <TableInput details
                            readOnly value={`${item.received}`}
                          ></TableInput>
                        </TableCell>
                        <TableCell align="center">
                          <TableInput details 
                            readOnly value={`${item.good_condition}`}
                          ></TableInput>
                        </TableCell>
                        <TableCell align="center">
                          <TableInput details 
                            readOnly value={`${item.bad_condition}`}
                          ></TableInput>
                        </TableCell>
                        <TableCell align="center">
                          <TableInput details
                            readOnly value={`${item.not_working}`}
                          ></TableInput>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </section>

          <MainTitle>Delivery Details</MainTitle>
          <Row className="w-100 p-0 m-0">
            <Col lg={3} md={6} xs={12}>
              <InputDiv >
                <Label>Mode of Transport</Label>
                <ApplyFormInput details type="text" readOnly value={"Air"} />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Courier/Flight No.</Label>
                <ApplyFormInput details type="text" readOnly value={"rt334"} />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Received Location</Label>
                <ApplyFormInput details type="text" readOnly value={"Mumbai"} />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Received by</Label>
                <ApplyFormInput details type="text" readOnly value={"Rahul Chat."} />
              </InputDiv>
            </Col>

            <Col md={9} xs={12}>
              <InputDiv>
                <Label>Remarks</Label>
                <ApplyFormInput details readOnly value={"none"} type="text" />
              </InputDiv>
            </Col>
            <Col lg={3} md={6} xs={12}>
              <InputDiv>
                <Label>Audit Status</Label>
                <ApplyFormInput details type="text" readOnly value={audit} />
              </InputDiv>
            </Col>
          </Row>
        </Container>
      </form>
    </AddItemContainer>
  );
};

export default MoreInwards;
const Container = styled.div`
  padding: 0 50px;
  @media only screen and (max-width: 1000px) {
    padding: 0 25px;
  }
`;
